<template>
  <div id="CustomerList">
    <div :class="`loader${loaderClass}`" v-show="loading"></div>
    <div class="bg-white data-table p-0" v-if="customerVal != undefined">
      <custom-pagination
        :page-changed="onPageChange"
        :per-page-changed="onPerPageChange" :moduleName="'CustomerList'">
      </custom-pagination>
      <vue-good-table
        ref="listConsumerTable"
        mode="remote"
        title="Customer"
        @on-page-change="onPageChange"
        @on-selected-rows-change="selectionChanged"
        @on-column-filter="onColumnFilter"
        @on-per-page-change="onPerPageChange"
        @on-sort-change="onSortChange"
        @on-select-all="onSelectAll"
        :totalRows="totalRecords"
        :columns="userColumns"
        :rows="rows"
        :pagination-options="{
                    enabled: false,
                    position: 'both',
                    perPage: perPage,
                    setCurrentPage:listCurrentPage,
                    perPageDropdown:dropDownPerPage,
                    dropdownAllowAll: false,
                }"
        :select-options="{
                enabled: canDeleteCustomer,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                }"
        :search-options="{
                enabled: false,
                }">

        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
          <div :key="key">
            <div v-if="props.column.field == 'action'">
              <router-link v-if="canUpdateCustomer" title="Edit Customer" v-bind:key="'action' + key"
                           class="fp-edit mr-3"
                           v-bind:to="{name: 'ConsumerEdit',params:{id:props.row.id}}"></router-link>
              <!-- <router-link v-if="canViewCustomer" title="View Customer" v-bind:key="'action_view' + key" class="fp-view" v-bind:to="{name: 'CustomerView',params:{id:props.row.id}}"></router-link> -->
            </div>
            <div v-else>
              {{ props.formattedRow[props.column.field] }}
            </div>
          </div>
        </template>
      </vue-good-table>
      <custom-pagination
        :page-changed="onPageChange"
        :per-page-changed="onPerPageChange" :moduleName="'CustomerList'">
      </custom-pagination>
    </div>
    <div class="bg-white data-table p-0" v-if="fuelCustomerListVal != undefined">
      <data-table-filter-config :moduleName="'customerList'" @cancelSelection="cancelAll" ref="filterComponent"
                                :allowSameFilter="'allow'"></data-table-filter-config>
      <section class="bg-white data-table">
        <custom-pagination
          :page-changed="onPageChange"
          :per-page-changed="onPerPageChange" :moduleName="'CustomerList'">
        </custom-pagination>
        <vue-good-table
          ref="listConsumerTable"
          mode="remote"
          title="Customer"
          @on-page-change="onPageChange"
          @on-selected-rows-change="selectionChanged"
          @on-column-filter="onColumnFilter"
          @on-per-page-change="onPerPageChange"
          @on-sort-change="onSortChange"
          @on-select-all="onSelectAll"
          @on-row-click="onRowClick"
          :totalRows="totalRecords"
          :columns="userColumns"
          :rows="rows"
          :pagination-options="{
                    enabled: false,
                    position: 'both',
                    perPage: perPage,
                    setCurrentPage:listCurrentPage,
                    perPageDropdown:dropDownPerPage,
                    dropdownAllowAll: false,
                }"
          :select-options="{
                enabled: canDeleteCustomer,
                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                selectionInfoClass: 'custom-class',
                selectionText: 'rows selected',
                clearSelectionText: 'clear',
                }"
          :search-options="{
                enabled: false,
                }">
        </vue-good-table>
        <custom-pagination
          :page-changed="onPageChange"
          :per-page-changed="onPerPageChange" :moduleName="'CustomerList'">
        </custom-pagination>
      </section>
    </div>
    <div id="page-content-wrapper" class="admin-content-area" v-else>
      <template v-if="cantAccessPage === true">
        <div class="page-name">
          <div class="page-title">{{ pageTitle }}</div>

          <div class="web-action-btn btn-groups text-right">
            <!-- Button for Clear Cache -->
            <clear-cache-data :pageKey="[pageKey]"></clear-cache-data>
            <!--                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >-->
            <!--                            <i class="fp-import"></i> Import-->
            <!--                        </a>-->
            <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
              <i class="fp-export"></i> Export
            </a>
            <template v-if="customerReportVal == undefined && canAddCustomer && hideButton === false">
              <router-link class="btn btn-primary" v-bind:to="{name: 'ConsumerCreate'}"><i class="fp-add"></i> Add
                Customer
              </router-link>
            </template>
          </div>
          <div class="mobile-action-btn elipse-btn">
            <button type="button" class="btn btn-elipse" data-toggle="dropdown" data-toggle-position="left"
                    aria-expanded="true" v-on:click.prevent="myFunction">
              <i class="fp-ellipsis-v"></i>
            </button>
            <div id="myDropdown" class="dropdown-content">
              <ul>
                <li>
                  <template v-if="canAddCustomer && customerReportVal == undefined  && hideButton === false">
                    <router-link v-bind:to="{name: 'ConsumerCreate'}"> Add Customer
                    </router-link>
                  </template>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="container-fluid">
          <div class="admin-page-content customer-list">
            <data-table-filter-config :moduleName="'customerList'" ref="filterComponent" @cancelSelection="cancelAll"
                                      :allowSameFilter="'allow'"></data-table-filter-config>
            <div class="data-table bg-white overflow-hidden">
              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process.
                batch no. is {{ batchNum }}.
                <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank"
                             @click.native="batchProcess = 0"> Click Here
                </router-link>
                to check file status!
              </p>
              <section class="bg-white data-table">
                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange" :moduleName="'customerList'" :position="'top'">
                </custom-pagination>
                <vue-good-table
                  ref="listConsumerTable"
                  mode="remote"
                  title="Customer"
                  @on-page-change="onPageChange"
                  @on-selected-rows-change="selectionChanged"
                  @on-column-filter="onColumnFilter"
                  @on-per-page-change="onPerPageChange"
                  @on-sort-change="onSortChange"
                  @on-select-all="onSelectAll"
                  :totalRows="totalRecords"
                  :columns="userColumns"
                  :rows="rows"
                  :pagination-options="{
                                          enabled: false,
                                          setCurrentPage:listCurrentPage,
                                          perPage: perPage,
                                      }"
                  :select-options="{
                                        enabled: canDeleteCustomer,
                                        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                        selectionInfoClass: 'custom-class',
                                        selectionText: 'rows selected',
                                        clearSelectionText: 'clear',
                                      }"
                  :search-options="{
                                      enabled: false,
                                      }">

                  <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                    <div :key="key" v-if="customerReportVal == undefined && hideButton == false">
                      <div v-if="props.column.field == 'action'">
                        <router-link v-if="canUpdateCustomer" title="Edit Customer" v-bind:key="'action' + key"
                                     class="fp-edit"
                                     v-bind:to="{name: 'ConsumerEdit',params:{id:props.row.id}}"></router-link>
                      </div>
                      <!-- <div v-if="props.column.field == 'code'">
                          <router-link v-if="canViewCustomer" title="View Customer" class="color-blue" v-bind:key="'action_view' + key" v-bind:to="{name: 'CustomerView',params:{id:props.row.id}}">{{props.row.code}}</router-link>
                      </div> -->
                      <div>
                        {{ props.formattedRow[props.column.field] }}
                      </div>
                    </div>
                  </template>
                </vue-good-table>

                <custom-pagination
                  :page-changed="onPageChange"
                  :per-page-changed="onPerPageChange">
                </custom-pagination>
              </section>
            </div>
            <div class="modal fade checklist-action-modal" id="checklist-action-modal" ref="checkListActionModal"
                 data-backdrop="static" data-keyboard="false" aria-labelledby="checkListActionModal" aria-hidden="true">
              <div class="modal-dialog modal-md" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Are you sure that you want to delete this Customer?</h5>
                    <button type="button" class="close" id="btnModalClose" v-on:click="hideModal()">&times;</button>
                  </div>
                  <div class="modal-body">
                    <h5>Checklist Actions</h5>
                    <template v-if="checkListActionsArray.length == 0">
                      <label class="no-checklist">No Checklist Actions Found.</label>
                    </template>
                    <template v-else>
                      <template v-for="(action,actionIndex) in checkListActionsArray">
                        <div :Key="actionIndex" class="checkbox-items">
                          <label class="custome-checkbox">
                            <input type="checkbox" v-bind:value="action.child_action_id" name="checklistActions[]"
                                   v-model="checkListActionData.module_checklist"
                                   v-bind:id="'action_Id_' + action.child_action_id +'_'+action.child_action">
                            {{ action.child_action }}
                            <span class="checkmark"></span>
                          </label>
                        </div>
                      </template>
                    </template>
                  </div>
                  <div class="modal-footer">
                    <button class="btn btn-primary" id="btnModalOk" v-on:click="storeModuleChecklistActions()"> Ok
                    </button>
                    <button class="btn btn-tertiary" id="btnModalCancel" v-on:click="hideModal()"> Cancel</button>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal fade part-upload-modal" id="part-upload-modal" ref="part-upload-modal"
                 data-backdrop="static" data-keyboard="false" aria-labelledby="part-upload-modal" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Select File</h5>
                  </div>
                  <div class="modal-body">
                    <form id="importIFTAFile" class="addinspectionForm">
                      <div class="form-row">
                        <div class="col form-group">
                          <label class="control-label require mb-2" for="name">File:</label><br/>
                          <input id="partUploadFile" type="file" @change="onFileChanged">
                          <div class="field-error">{{ import_error }}</div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col form-group" v-if="fileName != ''">
                          <label class="control-label"> Download Sample file </label>
                          <a href="javascript:void(0)" v-on:click="downloadSample()"> <i class="fp-text-document"></i>
                            {{ fileName }} </a>
                        </div>
                      </div>

                      <p v-if="importedCount > 0"><i class="fa fa-check" aria-hidden="true"></i>
                        &nbsp;<strong>{{ importedCount }} Records imported</strong></p>
                    </form>

                    <div class="modal-footer">
                      <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"><i class="fp-close"> </i>Cancel
                      </button>
                      <button class="btn btn-primary" id="importButton" v-on:click="importParts()"><i
                        class="fp-import"> </i> Import
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal fade price-book-modal" id="price-book-modal" ref="price-book-modal" data-backdrop="static"
                 data-keyboard="false" aria-labelledby="price-book-modal" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Select File</h5>
                  </div>
                  <div class="modal-body">
                    <form id="importIFTAFile" class="addinspectionForm">
                      <div class="form-row">
                        <div class="col form-group">
                          <label class="control-label" for="cost_type">Cost Type:</label>
                          <v-select id="cost_type" :close-on-select="true" class="close-remove"
                                    v-model="costType"
                                    :options="costTypeArr"
                                    name="cost_type" placeholder="Select Cost Type" label="text">
                          </v-select>
                          <div class="field-error">{{ cost_type_error_msg }}</div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col form-group">
                          <label class="control-label require mb-2" for="name">File:</label><br/>
                          <input id="priceBookUploadFile" type="file" @change="onFileChangedPriceBook">
                          <div class="field-error">{{ importPriceBookError }}</div>
                        </div>
                      </div>
                      <div class="form-row">
                        <div class="col form-group" v-if="priceBookFileName != ''">
                          <label class="control-label"> Download Sample file </label>
                          <a href="javascript:void(0)" v-on:click="downloadSamplePriceBook()"> <i
                            class="fp-text-document"></i> {{ priceBookFileName }} </a>
                        </div>
                      </div>

                      <p v-if="importedCountPriceBook > 0"><i class="fa fa-check" aria-hidden="true"></i> &nbsp;<strong>{{ importedCountPriceBook }}
                        Records imported</strong></p>
                    </form>

                    <div class="modal-footer">
                      <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"><i class="fp-close"> </i>Cancel
                      </button>
                      <button class="btn btn-primary" id="importButton" v-on:click="importPriceBook()"><i
                        class="fp-import"> </i> Import
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </template>
      <template v-else-if="cantAccessPage === false">
        <div class="container-fluid">
          <div class="bg-white text-center">
            <h1>
              Oops!</h1>
            <h2>
              403 </h2>
            <div class="error-details">
              Sorry!, You don't have permission to access this page.
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <loading-content></loading-content>
      </template>
      <app-footer></app-footer>
    </div>
  </div>
</template>
<script>

import EventBus from "./event-bus";
import Vue from "vue";
import {commonMixins} from '../mixins/commonMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';

import {locale} from 'moment';

export default {
  name: "ConsumerList",
  mixins: [commonMixins, dataTableMixins],
  props: {
    customerVal: {
      type: String,
      required: false,
      default: undefined
    },
    fuelCustomerListVal: {
      type: String,
      required: false,
      default: undefined
    },
    customerReportVal: {
      type: String,
      required: false,
      default: undefined
    }
  },
  data: () => ({
    pageTitle: "Customer List",
    hideButton: false,
    firstLoad: 0,
    permissions: [],
    userColumns: [],
    cantAccessPage: "",
    velocity_env: process.env.NODE_ENV,
    columns: [
      {
        label: 'Actions',
        field: 'action',
        hidden: true,
        sortable: false,
      },
      {
        label: 'Customer Code',
        field: 'code',
        filterable: true,
        fpFieldType: "text",
        width: '140px',
        hidden: false,
      },
      {
        label: 'Customer Name',
        field: 'name',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
      },
      {
        label: 'Contact Name',
        field: 'contact_name',
        filterable: true,
        fpFieldType: "text",
        hidden: false,
      },
      {
        label: 'Email',
        field: 'email',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Phone',
        field: 'phone_no',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'City',
        field: 'city',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'State',
        field: 'state',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },


      {
        label: 'Status',
        field: 'status',
        fpFieldType: "option",
        filterable: true,
        hidden: false,
        filterOptions: {
          enabled: false, // enable filter for this column
          placeholder: "All", // placeholder for filter input
          filterValue: '', // initial populated value for this filter
          filterDropdownItems: ['Unverified', 'Active', 'Inactive'],
          trigger: "enter" //only trigger on enter not on keyup
        }
      },

      {
        label: 'User (Dealer Role)',
        field: 'dealer_name',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Mapped Dealer',
        field: 'mapped_dealer',
        fpFieldType: "text",
        filterable: true,
        hidden: false,
      },
      {
        label: 'Date Added',
        field: 'created_at',
        fpFieldType: "date",
        filterable: true,
        hidden: false,
      },
    ],
    rows: [],
    totalRecords: 0,
    loading: false,
    customerStage: "",
    custId: 0,
    action: "list",
    action_name: "remove customer",
    checkListActionsArray: [],
    checkListActionData: {
      parent_action: '',
      module_checklist: [],
      reference: 'customer',
      reference_id: []
    },
    canAddCustomer: false,
    canUpdateCustomer: false,
    canViewCustomer: false,
    canDeleteCustomer: false,
    canAddCustomerContact: false,
    pageKey: "_customer_list_",
    batchProcess: 0,
    batchNum: "",
    importedCount: 0,
    import_error: '',
    fileName: '',
    importedCountPriceBook: 0,
    importPriceBookError: '',
    priceBookFileName: '',
    costType: [],
    costTypeArr: [
      {value: 'L', text: 'Labors'},
      {value: 'M', text: 'Parts'},
    ],
    cost_type_error_msg: '',
  }),
  metaInfo() {
    return {
      title: (this.customerReportVal == undefined) ? "Customer List | " + process.env.COPYRIGHT_NAME : "Customer Register Report | " + process.env.COPYRIGHT_NAME
    }
  },
  watch: {

    //check permission change
    permissions: function (permissions) {

      var self = this;
      if (permissions.length > 0) {

        for (const element of permissions) {
          if (element.name == 'ev_list_customer') {
            self.cantAccessPage = true;
          } else if (element.name == 'ev_delete_customer') {
            if (self.$route.query.flag == 'customerReport') {

              self.canDeleteCustomer = false;
              self.canDeleteCustomer = true;
            }
          } else if (element.name == 'ev_view_customer') {
            self.canViewCustomer = true;
          } else if (element.name == 'ev_add_customer') {
            self.canUpdateCustomer = true;
            for (const element of this.columns) {
              if (element.field == 'action') {
                this.$set(element, 'hidden', false)
              }
            }
            self.canAddCustomer = true;
          } else if (element.name == 'ev_add_customer_contact') {
            self.canAddCustomerContact = true;
          }
        }
      }

    }

  },
  created: function () {
    this.serverParams.sort = {field: "updated_at", type: "desc"};
  },
  mounted: function () {

    var self = this;
    self.getPermissions();
    if (self.$route.query.flag == 'customerReport') {
      self.hideButton = true;
      self.pageTitle = "Customer Listing";
    }

    for(const element of this.columns) {
      if (element.field === 'state'){
        this.$set(element, 'label', this.state_province);
      }
    }

    // if( self.customerReportVal == 'registerreport' || self.$route.query.flag == 'customerReport' ){
    //
    //     for(const element of this.columns) {
    //         if ( element.field == 'action' ) {
    //             this.$set(element, 'hidden', true)
    //         }
    //     }
    //
    // }
  },
  methods: {

    cancelAll: function (cancelAll) {
      this.$refs.listConsumerTable.unselectAllInternal();
    },
    titleCase(str) {
      if (str == null) {
        return;
      } else {
        var value = str.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    },

    onRowClick(params) {
      if (params.row.id != '') {
        var index = params.row.id;
        if (index > -1) {
          this.$emit('fuelPricingCustomerId', index)
        }
      } else {
        return "Nothing is selected!";
      }
    },

    //for populate customer's current stage in dropdown and to change stage of customer
    selectionChanged(param) {

      var self = this;
      self.serverParams.selectedAll = false;
      if (param.selectedRows.length == 100) {
        EventBus.$emit('clear-selection', false);
      } else {
        EventBus.$emit('clear-all-flags', false);
      }
      return;
    },
    exportCheck: function () {
      var self = this;
      var count = 0;
      var actionFlag = "";
      var data = this.$refs['listConsumerTable'].selectedRows;
      count = data.length;

      if (this.serverParams.selectedAll == true) {
        actionFlag = "";
      } else if (count != 0 && count <= 100) {
        actionFlag = "export";
      }

      this.exportReports(actionFlag);
    },
    loadCustomerStage(id) {

      var self = this;

      $.ajax({
        url: process.env.ROOT_API + "/customer/" + id,
        type: "GET",
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          // console.log(data);
          if (data.status == "success") {
            self.customerStage = {text: self.titleCase(data.content.stage), value: data.content.stage};
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, 'cust-stage-change')
        }
      });
    },


    loadList() {

      var self = this;

      if (self.customerReportVal == 'registerreport') {
        self.flag = 'registerreport';
      }

      self.loading = true;
      //get selected customers ids

      var selectedRows = [];

      if (self.firstLoad == 1) {
        //because on first load list not initialize
        var data = this.$refs['listConsumerTable'].selectedRows;
        for (var i = 0; i < data.length; i++) {
          selectedRows.push(this.$refs['listConsumerTable'].selectedRows[i].id)
        }
      }

      var fields = {

        page: self.serverParams.page,
        perPage: self.serverParams.perPage,
        filters: self.serverParams.columnFilters,
        sort: self.serverParams.sort,
        flag: self.flag,
        selectedRows: selectedRows,
        action: self.action,
        selectedAll: self.serverParams.selectedAll

      };

      self.firstLoad = 1;
      $.ajax({
        url: process.env.ROOT_API + "/consumer/list",
        type: "POST",
        data: fields,
        headers: this.ajxHeaders,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          // console.log(data);
          if (data.status == "success") {

            if (self.action == "delete") {

              self.action = "list";
              $("#deleteCustomerBtn").val("Delete");

              self.$refs.filterComponent.clearSelectAll();
              self.loadList();

            } else if (self.action == "export" || self.action == "export_queue") {
              if (data.code == "201") {
                alert(data.message);
              } else {
                if (self.action == "export") {
                  self.excel = data.content;
                  var save = document.createElement("a");
                  save.href = self.excel;
                  save.download = data.content;
                  save.target = "_blank";

                  document.body.appendChild(save);
                  save.click();
                  document.body.removeChild(save);

                } else {

                  self.batchProcess = 1;
                  self.batchNum = data.content;
                }
              }
              self.action = "list";
              // self.loadList();

            } else {

              self.rows = data.content.row;
              self.totalRecords = data.content.totalRecords;
              self.filteredFlag = false;

            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          if (self.action == "delete") {
            self.generateStatusCodeMessage(jqXHR, true, 'customer-delete-error')
          } else if (self.action == 'export') {
            self.generateStatusCodeMessage(jqXHR, true, 'customer-export-error')
          } else {
            self.generateStatusCodeMessage(jqXHR, false, 'customer-list-error')
          }

        }
      });
    },

    //for change selected customer stage
    changeStage: function () {
      var self = this;

      var data = this.$refs['listConsumerTable'].selectedRows;
      var use = [];
      if (self.customerStage == null || !self.customerStage.value || self.customerStage.value == '') {
        self.$swal('', 'Please Select Atleast One Stage', 'info');
        return;
      }
      var stage = self.customerStage.value;
      if (self.customerStage.value == 'credit approved') {
        stage = 'new';
      }
      for (var i = 0; i < data.length; i++) {
        use.push(this.$refs['listConsumerTable'].selectedRows[i].id)
      }
      if (use.length > 1) {
        self.$swal('', 'Please Select Atmost One Customer', 'info');
        return;
      }
      $.ajax({
        url: process.env.ROOT_API + "/change-stage",
        type: "POST",
        data: {
          customer_id: use[0],
          stage: stage
        },
        headers: this.ajxHeaders,
        dataType: 'json',
        success: function (data) {
          self.loading = false;
          if (data.code == '200') {
            self.loadList();
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, 'change-stage-error')
        }
      });
    },

    customerDelete() {

      //checklist action changes
      var self = this;
      self.loading = true;
      $("#checklist-action-modal").modal("show");
      console.log(self.action_name);
      $.ajax({
        url: process.env.ROOT_API + "/checklist-actions-from-name/search",
        type: "POST",
        headers: this.ajxHeaders,
        crossDomain: true,
        dataType: "json",
        data: {
          action_name: self.action_name,
        },
        success: function (data) {
          // console.log(data);
          self.loading = false;
          if (data.status == "success") {
            self.checkListActionData.parent_action = data.content.parent_id;
            self.checkListActionsArray = data.content.checkListActionsArray;
          } else {
            self.loading = false;
            self.checkListActionsArray = [];
          }

        },
        error: function (jqXHR, exception) {

          self.generateStatusCodeMessage(jqXHR, true, 'customer-checklist-message')
        }
      });

    },


    syncCustomer() {

      var self = this;
      self.loading = true;
      $("#syncCustomerBtn").text("Syncing...");
      $("#syncCustomerBtn").prop("disabled", true);

      $.ajax({
        url: process.env.ROOT_API + "/sync-customer",
        type: "GET",
        // data: 'id=' + use,
        headers: this.ajxHeaders,
        dataType: 'json',
        success: function (data) {

          self.loading = false;
          $("#syncCustomerBtn").text("Sync");
          $("#syncCustomerBtn").prop("disabled", false);

          if (data.status == 'success') {

            self.$swal({
              // title: data.content + " " ,
              text: data.content + " Customer are Sync.",
              type: "success",
              confirmButtonText: "Confirm",
            }).then(result => {
              if (result.value) {
                self.loadList();
              }
            });
          }
        },
        error: function (jqXHR, exception) {

          self.loading = false;
          $("#syncCustomerBtn").text("Sync");
          $("#syncCustomerBtn").prop("disabled", false);

          self.generateStatusCodeMessage(jqXHR, true, 'sync-customer')
        }
      });

    },
    storeModuleChecklistActions() {
      var self = this;
      var data = this.$refs['listConsumerTable'].selectedRows;
      var use = [];
      self.checkListActionData.reference_id = [];
      for (var i = 0; i < data.length; i++) {
        use.push(this.$refs['listConsumerTable'].selectedRows[i].id);
        self.checkListActionData.reference_id.push(this.$refs['listConsumerTable'].selectedRows[i].id);
      }

      $("#btnModalOk").prop("disabled", true);
      $("#btnModalCancel").prop("disabled", true);
      $("#btnModalClose").prop("disabled", true);

      $.ajax({
        url: process.env.ROOT_API + "/module-action-checklist/create",
        type: "POST",
        headers: this.ajxHeaders,
        crossDomain: true,
        dataType: "json",
        data: {
          moduleActionChecklist: self.checkListActionData,
        },
        success: function (data) {

          $("#btnModalOk").prop("disabled", false);
          $("#btnModalCancel").prop("disabled", false);
          $("#btnModalClose").prop("disabled", false);
          //perform delete action
          self.hideModal();
          self.action = "delete";
          //$("#deleteCustomerBtn").val("Deleting ...");
          self.loadList();

        },
        error: function (jqXHR, exception) {
          $("#btnModalOk").prop("disabled", false);
          $("#btnModalCancel").prop("disabled", false);
          $("#btnModalClose").prop("disabled", false);

          self.generateStatusCodeMessage(jqXHR, true, 'store-checklist-message')
        }
      });

    },
    hideModal() {
      var self = this;
      $("#checklist-action-modal").modal("hide");
      self.checkListActionData.reference_id = [];
      self.checkListActionData.module_checklist = [];
      self.checkListActionsArray = [];

    },
    openModal: function () {
      let self = this;
      self.importedCount = 0;
      self.selectedFile = "";
      $("#partUploadFile").val('');
      self.import_error = '';
      self.generateExcelSample();
      $('#part-upload-modal').modal('show');
    },
    onFileChanged(event) {
      const file = event.target.files[0];
      let self = this;
      self.selectedFile = file;
      self.import_error = '';
    },
    generateExcelSample() {
      let self = this;
      $.ajax({
        url:
          process.env.ROOT_API + "/customer-excel/generate",
        type: "POST",
        crossDomain: true,
        dataType: "json",
        headers: this.ajxHeaders,
        success: function (data) {
          self.loading = false;
          self.fileName = data.content.file;
          self.file = data.content.web;

        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, 'part-upload-generate')

        }
      });
    },
    downloadSample() {
      let self = this;
      let docPath = self.file;
      let save = document.createElement('a');
      save.href = docPath;
      save.download = docPath;
      save.target = '_blank';
      document.body.appendChild(save);
      save.click();
      document.body.removeChild(save);
    },
    importParts() {
      let self = this;
      self.import_error = "";

      if (self.selectedFile == "" || self.selectedFile == null) {
        self.import_error = "Please Select Excel File.";
        return;
      }
      let fileExtension = ['xls', 'xlsx'];
      if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
        self.import_error = "Only formats are allowed : " + fileExtension.join(', ');
        return;
      }

      let formData = new FormData();
      formData.append('myFile', self.selectedFile);

      self.loading = true;
      $('#importButton').text('Fetching...');
      $('#importButton').prop('disabled', true);
      $('#cancelButton').prop('disabled', true);

      $.ajax({
        url: process.env.ROOT_API + "/customer-excel/import",
        type: "POST",
        data: formData,
        headers: this.ajxHeaders,
        crossDomain: true,
        processData: false,
        contentType: false,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          $('#importButton').text('Import');
          $('#importButton').prop('disabled', false);
          $('#cancelButton').prop('disabled', false);
          self.import_error = '';
          if (data.code == 400) {
            self.import_error = data.message;
            return;
          }
          if (data.status == "success") {

            if (Object.keys(data.duplicate).length > 0) {

              self.importedCount = data.content;

            } else {
              if (data.content != false) {
                self.$swal('', data.content + " Records imported", 'success');
              }
              $('#part-upload-modal').modal('hide');
              self.loadList();
            }

          }

        },
        error: function (jqXHR, exception) {
          self.loading = false;
          $('#importButton').text('Import');
          $('#importButton').prop('disabled', false);
          $('#cancelButton').prop('disabled', false);
          self.generateStatusCodeMessage(jqXHR, true, 'part-upload-import-error')
        }
      });
    },
    priceBookImportModal: function () {
      let self = this;
      self.costType = {value: 'L', text: 'Labors'};
      self.importedCountPriceBook = 0;
      self.selectedFile = "";
      $("#priceBookUploadFile").val('');
      self.importPriceBookError = '';
      self.generateExcelSamplePriceBook();
      $('#price-book-modal').modal('show');
    },
    onFileChangedPriceBook(event) {
      const file = event.target.files[0];
      let self = this;
      self.selectedFile = file;
      self.importPriceBookError = '';
    },
    generateExcelSamplePriceBook() {
      let self = this;
      $.ajax({
        url:
          process.env.ROOT_API + "/pricebook-excel/generate",
        type: "POST",
        crossDomain: true,
        dataType: "json",
        headers: this.ajxHeaders,
        success: function (data) {
          self.loading = false;
          self.priceBookFileName = data.content.file;
          self.file = data.content.web;

        },
        error: function (jqXHR, exception) {
          self.loading = false;
          self.generateStatusCodeMessage(jqXHR, true, 'pricebook-upload-generate')

        }
      });
    },
    downloadSamplePriceBook() {
      let self = this;
      let docPath = self.file;
      let save = document.createElement('a');
      save.href = docPath;
      save.download = docPath;
      save.target = '_blank';
      document.body.appendChild(save);
      save.click();
      document.body.removeChild(save);
    },
    importPriceBook() {
      let self = this;
      self.importPriceBookError = "";

      if (self.selectedFile == "" || self.selectedFile == null) {
        self.importPriceBookError = "Please Select Excel File.";
        return;
      }
      let fileExtension = ['xls', 'xlsx'];
      if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
        self.importPriceBookError = "Only formats are allowed : " + fileExtension.join(', ');
        return;
      }

      let formData = new FormData();
      formData.append('myFile', self.selectedFile);
      let costTypeVal = '';
      if (self.costType != null && self.costType != '' && self.costType.value) {
        costTypeVal = self.costType.value;
      }
      formData.append('cost_type', costTypeVal);

      self.loading = true;
      $('#importButton').text('Fetching...');
      $('#importButton').prop('disabled', true);
      $('#cancelButton').prop('disabled', true);

      $.ajax({
        url: process.env.ROOT_API + "/pricebook-excel/import",
        type: "POST",
        data: formData,
        headers: this.ajxHeaders,
        crossDomain: true,
        processData: false,
        contentType: false,
        dataType: "json",
        success: function (data) {
          self.loading = false;
          $('#importButton').text('Import');
          $('#importButton').prop('disabled', false);
          $('#cancelButton').prop('disabled', false);
          self.importPriceBookError = '';
          if (data.code == 201) {
            self.importPriceBookError = data.message;
            return;
          }
          if (data.status == "success") {
            if (Object.keys(data.duplicate).length > 0) {
              self.importedCountPriceBook = data.content;
            } else {
              if (data.content) {
                self.$swal('', data.content + " Records imported", 'success');
              }
              $('#price-book-modal').modal('hide');
              self.loadList();
            }
          }
        },
        error: function (jqXHR, exception) {
          self.loading = false;
          $('#importButton').text('Import');
          $('#importButton').prop('disabled', false);
          $('#cancelButton').prop('disabled', false);
          self.generateStatusCodeMessage(jqXHR, true, 'pricebook-upload-import-error')
        }
      });
    },

  }
};
</script>



// WEBPACK FOOTER //
// src/components/ConsumerList.vue